import { useEffect } from 'react';

import { env } from '@/config/env';
import { useSessionAvatar } from '@/hooks/useSessionAvatar';
import { resolveFileUrl } from '@/utils/formatters';

/**
 * Pushes the candidate's stored profile-photo URL into the app-wide avatar state so the generic
 * chrome (top-bar avatar, etc.) shows it without importing this feature. Mounted app-wide for the
 * session via `SessionAvatarSync` — its single caller, deliberately: two writers pushing to one
 * context is how a route that happened to skip its query could blank an avatar another had set. When
 * a new photo is uploaded and the profile refetches, the resolved URL changes and every
 * `SessionAvatar` updates immediately.
 */
export function useSyncSessionAvatar(rawPhotoUrl: string | null | undefined): void {
  const { setPhotoUrl } = useSessionAvatar();

  useEffect(() => {
    setPhotoUrl(rawPhotoUrl ? resolveFileUrl(rawPhotoUrl, env.gatewayUrl) : null);
  }, [rawPhotoUrl, setPhotoUrl]);
}
